import { AmortizationSystem } from "../types/ownerDashboard.types";

export function resolveAmortizationSystem(
  system?: AmortizationSystem | null
): AmortizationSystem {
  return system ?? "price";
}
